import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next'

import QuestionType from './QuestionType';
import useStyles from './styles';
import {
  SingleChoiceQuestion,
  MultipleChoiceQuestion,
} from './NChoiceQuestion';

import {
  translateQuestionTypes
} from './questionTypesConsts';
import OpenQuestion from './OpenQuestion';
import RatingQuestion from './RatingQuestion';


const AddQuestionModalContent = ({
  onConfirm, onHide, additionalData,
}) => {
  const { t } = useTranslation(['translation']);
  const QUESTION_TYPE = 'questionType'
  const {
    SINGLE_CHOICE_QUESTION,
    MULTIPLE_CHOICE_QUESTION,
    OPEN_QUESTION,
    RATING_QUESTION,
  } = translateQuestionTypes(t);
  const question = additionalData ? additionalData.question : null;
  const editMode = additionalData ? additionalData.editMode : false;
  const defaultStep = question ? question.type : QUESTION_TYPE;
  const defaultType = question ? question.type : SINGLE_CHOICE_QUESTION;

  const [step, setStep] = useState(defaultStep);
  const [currentType, setCurrentType] = useState(defaultType);


  const onSelectQuestionType = type => {
    setStep(type);
    setCurrentType(type);
  };

  const onGoBack = () => {
    setStep(QUESTION_TYPE);
  };

  const Component = {
    [SINGLE_CHOICE_QUESTION]: SingleChoiceQuestion,
    [MULTIPLE_CHOICE_QUESTION]: MultipleChoiceQuestion,
    [OPEN_QUESTION]: OpenQuestion,
    [RATING_QUESTION]: RatingQuestion,
  }[step];

  const classes = useStyles();
  return (
    <div className={classes.modalContentContainer}>
      {step === QUESTION_TYPE && (
        <QuestionType
          onHide={onHide}
          onConfirm={onSelectQuestionType}
          type={currentType}
        />
      )}
      {step !== QUESTION_TYPE && (
        <Component
          onGoBack={editMode ? () => {} : onGoBack}
          onConfirm={onConfirm}
          onHide={onHide}
          question={question}
          editMode={editMode}
        />
      )}
    </div>
  );
};


AddQuestionModalContent.defaultProps = {
  additionalData: null,
};

AddQuestionModalContent.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  additionalData: PropTypes.shape({
    question: PropTypes.object.isRequired,
    editMode: PropTypes.bool.isRequired,
  }),
};

export default AddQuestionModalContent;
